module.exports = __webpack_public_path__ + "static/media/veritas-screenshot-3.5d61d554.png";